// @flow
import type { FullState } from '../../../types';
import type { Pagination } from '../../types';

export const selectPagination = (state: FullState): Pagination =>
  state.domainSuggest.pagination;
export const selectCanLoadMore = (state: FullState): boolean => {
  const pagination = selectPagination(state);
  if (!pagination) {
    return false;
  }

  const { page, perPage, total } = pagination;
  // $FlowFixMe[sketchy-number-and]
  return !!(page && perPage && total && page * perPage < total);
};
